<footer class="footer">
  <div class="footer__divider"></div>

  <!-- Base section -->
  <div class="footer__base">
    <div footer__logo-and-copyright>
      <div class="footer__logo">
        <img
          src="assets/images/footer/logo-red.png"
          alt="Reliance Industries Limited"
        />
      </div>
      <div class="footer__copyright">
        <p>
          Copyright © 2026 Reliance Industries Limited. All rights reserved.
        </p>
      </div>
    </div>
    <div class="footer__links">
      <a href="/" class="footer__link" [routerLink]="['/privacy-policy']">
        Privacy policy</a
      >
      <a href="/" class="footer__link" [routerLink]="['/terms-conditions']"
        >Terms &amp; Conditions</a
      >
    </div>
  </div>
</footer>
